module.exports = __webpack_public_path__ + "img/bill.8fb97a01.svg";